import React from 'react'
import { createRoot } from 'react-dom/client'
import { toast } from 'react-toastify'
import LoadingPopup from '../components/LoadingPopup'

// Direct links finish when handed to the browser; browser transfers have no completion event.
export const beginDownloadProgress = (message = 'Downloading...') => {
    const container = document.createElement('div')
    document.body.appendChild(container)
    const root = createRoot(container)
    const started = Date.now()
    root.render(<LoadingPopup visible message={message} />)
    let finished = false
    return () => {
        if (finished) return
        finished = true
        setTimeout(() => { root.unmount(); container.remove() }, Math.max(0, 700 - (Date.now() - started)))
    }
}

export const withDownloadProgress = async (action, message = 'Downloading...') => {
    const finish = beginDownloadProgress(message)
    try {
        // Let the popup paint before synchronous PDF/CSV generation starts.
        await new Promise(resolve => setTimeout(resolve, 32))
        return await action()
    } catch (error) {
        toast.error(error?.message || 'Unable to download file.')
    } finally {
        finish()
    }
}

export const showLinkDownloadProgress = () => beginDownloadProgress()()
